import React from "react";
import { Box, Typography } from "@mui/material";

export const RangeOutlineBox = (props: RangeOutlineProps) => {
  const { children, label } = props;

  return (
    <Box sx={rangeOutlineStyle}>
      <Typography sx={labelStyle}>{label}</Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>{children}</Box>
    </Box>
  );
};

export type RangeOutlineProps = {
  label: string;
  children?: React.ReactNode;
};

const rangeOutlineStyle = [
  {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    color: (theme) => theme.palette.grey["700"],
    border: (theme) => `${theme.palette.grey["200"]} 1px solid`,
    borderRadius: "8px",
    marginTop: "20px",
    padding: "0px 8px 5px 5px",
  },
  (theme) => ({
    "&:hover": {
      borderColor: (theme) => theme.palette.grey["900"],
    },
  }),
];
const labelStyle = {
  fontSize: "14px",
  margin: "5px 7px 0 3px",
  lineHeight: "1",
};
